export const environment = {
  production: false,
  apiurl: 'https://ivapi.knackbe.in/api' 
  // apiurl:`http://154.61.75.209:5000/api/`
};
